import { Col, Input, Row } from 'antd'
import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useState } from 'react'
// Components
import Title from 'antd/lib/typography/Title'
import TagGroup from '../../../components/TagGroup'
import HandleInputTags from '../../../helpers/HandleInputTagsHelpers'
import AddMore from '../component/AddMore'
import FiltersCount from '../component/FiltersCount'
import FiltersLayout from '../component/FiltersLayout'
import { setIsOpen } from '../helpers/actionHelpers'
import isAnyField from '../helpers/isAnyField'
import { AddButton } from './styled'

const SearchByTitle = ({ existedFilters, setExistedFilters }) => {
  const [values, setValues] = useState({
    titleValue: '',
    title: [],
    excludeTitleValue: '',
    excludeTitle: [],
    isExcludeTitle: false,
    isOpen: false
  })

  const toggleOpen = useCallback(() => {
    setIsOpen(setValues, values)
  }, [values])

  const handleAdd = useCallback(
    (activeInputValue, activeInput) => {
      if (!values[activeInputValue]) return

      const tags = HandleInputTags(activeInputValue, activeInput, values)
      if (tags.length > 0 && values[activeInputValue]) {
        const updatedValues = {
          ...values,
          [activeInput]: tags,
          [activeInputValue]: '',
          isExcludeTitle: false
        }
        setValues(updatedValues)

        const updatedTitleFilter = {
          ...existedFilters?.title,
          current_title: {
            ...(updatedValues.excludeTitle?.length
              ? { mustNotHave: updatedValues.excludeTitle }
              : {}),
            ...(updatedValues.title?.length ? { shouldHave: updatedValues.title } : {})
          }
        }
        setExistedFilters({
          ...existedFilters,
          title: updatedTitleFilter
        })
      }
    },
    [values, existedFilters, setExistedFilters]
  )

  const handleDelete = (tags, activeTagsType) => {
    const updatedValues = { ...values, [activeTagsType]: tags }
    setValues(updatedValues)

    const updatedTitleFilter = {
      ...existedFilters.title,
      current_title: {
        ...(updatedValues.excludeTitle?.length ? { mustNotHave: updatedValues.excludeTitle } : {}),
        ...(updatedValues.title?.length ? { shouldHave: updatedValues.title } : {})
      }
    }

    setExistedFilters({
      ...existedFilters,
      title: updatedTitleFilter
    })
  }

  const clearIncludeFilters = () => {
    setValues({ ...values, title: [] })
    const prev = existedFilters.title?.current_title || {}
    const { shouldHave, ...rest } = prev
    setExistedFilters({
      ...existedFilters,
      title: {
        ...existedFilters.title,
        current_title: rest
      }
    })
  }

  const clearExcludeFilters = () => {
    setValues({ ...values, excludeTitle: [] })
    const prev = existedFilters.title?.current_title || {}
    const { mustNotHave, ...rest } = prev

    setExistedFilters({
      ...existedFilters,
      title: {
        ...existedFilters.title,
        current_title: rest
      }
    })
  }

  useEffect(() => {
    setValues((prev) => ({
      ...prev,
      title: existedFilters?.title?.current_title?.shouldHave || [],
      excludeTitle: existedFilters?.title?.current_title?.mustNotHave || []
    }))
  }, [existedFilters])

  return (
    <FiltersLayout
      title="TITLE"
      setIsOpen={toggleOpen}
      isOpen={values.isOpen}
      activeFilters={isAnyField({ title: values.title })}
      clearAllFilters={clearIncludeFilters}
    >
      {!values.title.length && !values.isOpen && (
        <Title level={4} disabled style={{ fontSize: '14px', marginBottom: 0 }}>
          All Titles
        </Title>
      )}
      {/* Included Titles */}
      <Row className="filters-tags" style={values.title.length ? { marginTop: '16px' } : undefined}>
        <TagGroup tags={values.title} onDelete={handleDelete} activeTagsType="title" />
      </Row>

      {values.isOpen && (
        <Row style={{ position: 'relative' }}>
          <Input
            name="titleValue"
            placeholder="Add Title"
            value={values.titleValue}
            onChange={(e) => setValues({ ...values, [e.target.name]: e.target.value })}
            onPressEnter={(e) => handleAdd('titleValue', 'title')}
          />
          <AddButton
            onClick={() => handleAdd('titleValue', 'title')}
            noBorder
            maxWidth
            absolute
            noBackground
            disabled={!values.titleValue}
          >
            Add
          </AddButton>
        </Row>
      )}

      {/* Excluded Titles */}
      <Col
        className={values.excludeTitle.length || values.isOpen ? 'exclude-tags-area' : ''}
        span={24}
      >
        {(values.excludeTitle.length > 0 || values.isOpen) && (
          <FiltersCount
            ExcludeField={values.excludeTitle}
            clearExcludeFilters={clearExcludeFilters}
            title={'Exclude Title'}
          />
        )}

        <Row className="filters-tags">
          <TagGroup
            tags={values.excludeTitle}
            isExlude={values.excludeTitle && true}
            onDelete={handleDelete}
            activeTagsType="excludeTitle"
          />
        </Row>

        {values.isExcludeTitle && values.isOpen && (
          <Row style={{ position: 'relative' }}>
            <Input
              name="excludeTitleValue"
              placeholder="Exclude Title"
              value={values.excludeTitleValue}
              onChange={(e) => setValues({ ...values, [e.target.name]: e.target.value })}
              onPressEnter={(e) => handleAdd('excludeTitleValue', 'excludeTitle')}
            />
            <AddButton
              onClick={() => handleAdd('excludeTitleValue', 'excludeTitle')}
              noBorder
              maxWidth
              absolute
              noBackground
              disabled={!values.excludeTitleValue}
            >
              Add
            </AddButton>
          </Row>
        )}
      </Col>

      {!values.isExcludeTitle && values.isOpen && (
        <Row
          className="excl-typo-row"
          onClick={() => setValues({ ...values, isExcludeTitle: !values.isExcludeTitle })}
        >
          <AddMore title="Exclude Title" />
        </Row>
      )}
    </FiltersLayout>
  )
}

SearchByTitle.propTypes = {
  setExistedFilters: PropTypes.func,
  existedFilters: PropTypes.object
}

export default SearchByTitle
